module.exports = __webpack_public_path__ + "img/noodle-bowl.b28d5d32.png";